import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    API_URL: 'https://qe4bm7huec.execute-api.us-east-1.amazonaws.com/d1',
    redirectURL: 'https://arap.dev.ap.alight.com',
    externalCognitoTokenURL: "https://arap-dev-ext.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoTokenURL: "https://arap-dev-int.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoAuthorizeURL: "https://arap-dev-int.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    sso_external_client_id: '66bco09gisoqtvnumurkga1b0',
    sso_internal_client_id: '7iamcld5qaf55qm3990nfqc0e5',
    sso_api_pwd: '',
    identityPoolId: "us-east-1:b6474117-c3eb-464c-9915-6b07b523e4bb",
    showAIButton: true,
    chatEnabled: true,
    chatClientCodes: [],
    chatAllowedUserIdSubstrings: [],
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    rumApplicationId: '3c84e419-9cb2-4abb-9882-f6dc43ac1bf4',
    websocketUrl: 'wss://0pt6oz1dsf.execute-api.us-east-1.amazonaws.com/dev',
    useApiMock: false,
    quicksightEmbedBaseUrl: "https://us-east-1.quicksight.aws.amazon.com/embed/",
};
